import { useEffect, useState } from "react";
import ButtonComponent from "../../../components/common/button/Button"
import Modal from "../../../components/common/modal/Modal";
import { WorkFlowApproval, WorkFlowApprovalFooter } from "../WorkflowManagement/WorkFLowApproverModal";
import { useMsal } from "@azure/msal-react";
import axios from "axios";

export const SendForApprovalModal = ({ rowCount, disableSendForApprovalButton, textAreaValueForSend, sendForApprovalAPI, selectedSinglePlant, setBulkPDTDisabled, setBulkPDTValue }) => {

    //Modal content props below
    const [openSendForApproval, setOpenSendForApproval] = useState(false);
    const [disableAddApprovalButton, setDisableAddApprovalButton] = useState(true);
    const [allUsers, setAllUsers] = useState([]);
    const [comments, setComments] = useState(textAreaValueForSend);
    const { instance } = useMsal();
    useEffect(() => {
        setComments(textAreaValueForSend);
        if (rowCount > 0) {
            getAllUser()
        }
    }, [openSendForApproval])

    const getAllUser = async () => {
        const account = instance?.getAllAccounts()[0];
        instance?.setActiveAccount(account);
        const tokenRequest = {
            scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
        };
        const response = await instance?.acquireTokenSilent(tokenRequest);
        const accessToken = response?.accessToken;
        const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/lt/approvers`;
        axios.get(url,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    withCredentials: true
                },
                params: {
                    plant: selectedSinglePlant?.[0] || localStorage.getItem("selectedLTPlantCode"),
                    userEmail: localStorage.getItem("data"),
                    ltRole: localStorage.getItem("LTRole"),
                    cdRole: localStorage.getItem("CDRole"),
                    ltRegion: localStorage.getItem("LTRegion")
                }
            }
        )
            .then(response => {
                const loggedInUserEmail = localStorage.getItem("data");
                const filteredUsers = response?.data.filter(user => user.email !== loggedInUserEmail);

                setAllUsers(filteredUsers)
            })
            .catch(error => {
                console.error('Error fetching the data:', error);
            });
    }

    const initialData = [
        { level: 1, name: '', email: '' }
    ];
    const [rows, setRows] = useState(initialData);
    const [key, setKey] = useState(0);


    const handleAddRow = () => {
        const newLevel = rows.length + 1;
        setRows([...rows, { level: newLevel, name: '', email: '' }]);
        setDisableAddApprovalButton(true);
    };
    const allNamesFilled = rows.every(row => row.name !== '');
    const handleDeleteRow = (index) => {
        const newRows = rows.filter((_, rowIndex) => rowIndex !== index);
        // Reassign levels
        const updatedRows = newRows.map((row, rowIndex) => ({
            ...row,
            level: rowIndex + 1
        }));
        setRows(updatedRows);
        setKey(prevKey => prevKey + 1); // Force re-render
    };

    const handleChangeApprover = (index, event, value) => {
        const newRows = [...rows];
        newRows[index]['name'] = value ? value.name : '';
        newRows[index]['email'] = value ? value.email : '';
        setRows(newRows);
        setDisableAddApprovalButton(false)
    };

    const handleClearAll = () => {
        setRows(initialData);
        setComments("");
        setKey(prevKey => prevKey + 1); // Force re-render
    };
    const onChangeComments = (e) => {
        setComments(e.target.value)
    };
    const onClickSendForApprovalButton = () => {
        setOpenSendForApproval(true);
    };
    const closeSendForApprovalModal = () => {
        setOpenSendForApproval(false);
        handleClearAll();
    };
    const callSendForApprovalAPI = () => {
        const filterRows = rows.filter(item => item.name);
        setOpenSendForApproval(false);
        handleClearAll();
        sendForApprovalAPI(filterRows, comments);
        // setBulkPDTDisabled(true);
        if (typeof setBulkPDTDisabled === 'function') {
            setBulkPDTDisabled(true);
        }
        if (typeof setBulkPDTValue === 'function') {
            setBulkPDTValue("");
        }
    };

    return (
        <>
            <ButtonComponent
                maxWidth="200px"
                label={"Send for Approval"}
                bgColor="black"
                color="white"
                onClick={onClickSendForApprovalButton}
                disabled={disableSendForApprovalButton}
            />
            <Modal
                className="sendForapprovalModal_cls"
                open={openSendForApproval}
                handleClose={closeSendForApprovalModal}
                title="Workflow Approval"
                action={
                    <WorkFlowApprovalFooter
                        disableSubmitButton={!allNamesFilled || comments.length === 0}
                        handleClearAll={handleClearAll}
                        sendForApprovalAPI={callSendForApprovalAPI}

                    />
                }
                content={
                    <WorkFlowApproval
                        className="sendForApprovalContent_cls"
                        checkBoxCount={rowCount}
                        disableAddApprovalButton={disableAddApprovalButton}
                        data={allUsers}
                        addApprover={handleAddRow}
                        onHandleDeleteIcon={handleDeleteRow}
                        key={key}
                        handleChangeApprover={handleChangeApprover}
                        allUsers={allUsers}
                        rows={rows}
                        comments={comments}
                        onChangeComments={onChangeComments}
                        allNamesFilled={allNamesFilled}
                    />
                }
                maxWidth="100px"
            />
        </>
    )
}